import { Percent, Wallet, type LucideIcon } from 'lucide-react-native';
import { StyleSheet, View } from 'react-native';

import { Text } from '@/components/Text';
import { colors, fontSizes, radii, spacing } from '@/constants/theme';
import type { SocialRewardTile } from '@/types/deal';

export type SocialRewardTilesProps = {
  tiles: SocialRewardTile[];
  testID?: string;
};

const ICONS: Record<string, LucideIcon> = { wallet: Wallet, percent: Percent };

/** "What you get": the deal's own reward tiles, side by side. Server copy, verbatim. */
export function SocialRewardTiles({ tiles, testID }: SocialRewardTilesProps) {
  return (
    <View style={styles.row} testID={testID}>
      {tiles.map((tile, i) => {
        const Icon = ICONS[tile.icon] ?? Wallet;
        return (
          <View key={i} style={styles.tile}>
            <View style={styles.iconTile}>
              <Icon size={20} color={colors.deepGreen} strokeWidth={2} />
            </View>
            <Text variant="bodyBold" color="deepGreen" style={styles.value}>
              {tile.value}
            </Text>
            <Text variant="caption" color="textMuted">
              {tile.caption}
            </Text>
          </View>
        );
      })}
    </View>
  );
}

const ICON_TILE = 36;

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: spacing.md,
  },
  tile: {
    flex: 1,
    gap: spacing.xs,
    padding: spacing.base,
    borderRadius: radii.lg,
    borderWidth: 2,
    borderColor: colors.electricGreen,
    backgroundColor: colors.surface,
  },
  iconTile: {
    width: ICON_TILE,
    height: ICON_TILE,
    borderRadius: radii.base,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacing.sm,
    backgroundColor: colors.surfaceSunken,
  },
  value: {
    fontSize: fontSizes['2xl'],
    lineHeight: 30,
  },
});
